import { QueryHookOptions } from '@apollo/client';
import gql from 'graphql-tag';
import { useCustomQuery } from '../../../../logic/api/graphQL/useCustomQuery';
import { MetaRuleGq, MetaRuleGqProps } from '../../models/MetaRuleGq';

export function useGetMetaRulesGq(
  command: CommandGq,
  options?: QueryHookOptions<DataGq, VariablesGq>
) {
  const query = useCustomQuery<DataGq, VariablesGq>(gqTag, {
    variables: { command },
    fetchPolicy: 'cache-and-network',
    ...options,
  });

  return {
    query,
    ...(query?.data ?? query?.previousData)?.projects?.getMetaRules,
  };
}

const gqTag = gql`
  query GetMetaRules($command: GetMetaRulesCommand!) {
    projects {
      getMetaRules(command: $command) {
        metaRules {${MetaRuleGqProps}}
        page
        rowsPerPage
        count
      }
    }
  }
`;

interface DataGq {
  readonly projects: {
    readonly getMetaRules: {
      readonly metaRules: MetaRuleGq[];
      readonly page: number;
      readonly rowsPerPage: number;
      readonly count: number;
    };
  };
}

export interface VariablesGq {
  command: CommandGq;
}

export interface CommandGq {
  projectId: number;
  metaRuleId?: number;
  searchTerm?: string;
  page: number;
  rowsPerPage: number;
  active?: boolean;
}
